import React from 'react'

import { feedbotToast } from '../../../../../../../../lib/feedbotToast'

export const toastNotifyDownloadFuzzyAnswerLogsSuccess = (logCount: number) => {
  const id = 'downloadFuzzyAnswerLogsSuccess'
  const title = 'Download fuzzy answer logs'

  const content = (
    <>Fuzzy answer logs were successfully downloaded. Number of downloaded logs is {logCount}.</>
  )

  feedbotToast.success({ title, content, id })
}

export const toastNotifyDownloadFuzzyAnswerLogsInfo = () => {
  const id = 'downloadFuzzyAnswerLogsInfo'
  const title = 'Download fuzzy answer logs'

  const content = (
    <>There were not found any fuzzy answer logs for download with given date range.</>
  )

  feedbotToast.info({ title, content, id })
}

export const toastNotifyDownloadFuzzyAnswerLogsError = () => {
  const id = 'downloadFuzzyAnswerLogsError'
  const title = 'Download fuzzy answer logs'

  const content = <>Download fuzzy answer logs has failed.</>

  feedbotToast.error({ title, content, id })
}
